<div class="app-splash-screen bg-header dark:bg-dark-header" [ngStyle]="{ left: windowWidth }" *ngIf="showSplash">
  <div class="app-splash-inner">
    <!-- Generic loading state -->
    <!-- <div class="app-logo generic" *ngIf="isThemeChanging">
      <div class="loading-spinner"></div>
    </div> -->

    <!-- Theme-specific logos -->
    <ng-container *ngIf="!isThemeChanging">
      <!-- Default/WARFIGHTERS theme -->
      <div class="app-logo" *ngIf="currentTheme === 'WARFIGHTERS'"></div>

      <!-- PavCon theme -->
      <div class="app-logo pavcon" *ngIf="currentTheme === 'PavCon'">
        <img src="./../../../assets/logos/pavcon.png" alt="PavCon" />
      </div>

      <!-- SAFiRE theme -->
      <div class="app-logo safire" *ngIf="currentTheme === 'SAFiRE'">
        <img src="./../../../assets/logos/safire.png" alt="SAFiRE" />
      </div>
    </ng-container>

    <!-- <div class="app-label">TOUCH POINT</div> -->
    <div class="app-loader">
      <div class="container-body">
        <div class="row">
          <div id="loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>